import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/modules/shadcn/ui/alert";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { VISION_UNAVAILABLE, VISION_UNAVAILABLE_DETAIL } from "./copy";

/**
 * Classes for the Vision content while the server cannot run it: visible so
 * the admin can see what the settings dialog would offer, but not editable —
 * the API rejects a Vision PUT on such a server anyway.
 */
export const VISION_MUTED_CLASS = "opacity-60 pointer-events-none select-none";

/** Shown in the settings dialog when no Vision backend is configured on the server. */
export const VisionUnavailableNotice = () => {
  const { t } = useTranslation(["label", "common"]);
  return (
    <Alert>
      <Info />
      <AlertTitle>{t(VISION_UNAVAILABLE)}</AlertTitle>
      <AlertDescription>{t(VISION_UNAVAILABLE_DETAIL)}</AlertDescription>
    </Alert>
  );
};
